module.exports = __webpack_public_path__ + "img/GN-1101.2a1616e1.png";